// The host <-> project wire protocol.
//
// A project renders in this realm as one Module Federation app (see
// presentation/main/Main.sub.App.view.js), so these names travel as direct calls over the
// bridge rather than as postMessage payloads. They must stay in sync with the project
// runtime's copy: seedbot-base-project/app/seed/views/context/protocol.js. The execution
// events and EXECUTION_CALLBACK are not here: the server pushes those straight to the app.

export const ControllerType = {
  ACTION: "ACTION",
  EVENT: "EVENT",
}

export const ControllerActions = {
  // App -> host
  ExecuteProcess: "EXECUTE_PROCESS",
  CleanMessages: "CLEAN_MESSAGES",
  RegisterChat: "REGISTER_CHAT",
  UnregisterChat: "UNREGISTER_CHAT",
  UpdateChatProps: "UPDATE_CHAT_PROPS",
  RegisterMenu: "REGISTER_MENU",
  UnregisterMenu: "UNREGISTER_MENU",
  UpdateMenuProps: "UPDATE_MENU_PROPS",
  SetMenuOpen: "SET_MENU_OPEN",
  TakeScreenshot: "TAKE_SCREENSHOT",
  SetAppStorage: "SET_APP_STORAGE",
  RequestAppStorage: "REQUEST_APP_STORAGE",
  SendChatMessage: "SEND_CHAT_MESSAGE",
  SubmitComponent: "SUBMIT_COMPONENT",
  CancelComponent: "CANCEL_COMPONENT",
  ShowComponent: "SHOW_COMPONENT",
  HideComponent: "HIDE_COMPONENT",
  Navigate: "NAVIGATE",
}

export const ControllerEvents = {
  OnAppStorageChanged: "ON_APP_STORAGE_CHANGED",
  OnScreenshotTaken: "ON_SCREENSHOT_TAKEN",
  OnShowComponent: "ON_SHOW_COMPONENT",
  OnHideComponent: "ON_HIDE_COMPONENT",
  OnNavigate: "ON_NAVIGATE",
}
